import { FC, ReactNode, useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router';
import { useAppGlobStore } from 'src/appGlobalStore';
import { XmSpinner } from 'src/component/spinner/XmSpinner';
import { RoutePath } from 'src/data/Routes';
import { MenuNode } from 'src/model/MenuNode';
import { commitSelection } from 'src/routing/domain/NavDomain';
import { GLOB } from 'src/util/Glob';

export type ToolSection = MenuNode & { readonly path: string; };

interface RouteToolSectionsProps {
  rootPath: RoutePath;
  title: string;
  sections: readonly ToolSection[];
  renderSection: (section: ToolSection) => ReactNode;
}

export const RouteToolSections: FC<RouteToolSectionsProps> = ({ rootPath, title, sections, renderSection }) => {
  const { section: slug } = useParams<'section'>();
  const [menuChildren, setMenuChildren] = useState<ToolSection[]>(null);
  const section = sections.find(s => s.path === '/' + slug) ?? null;

  useEffect(() => {
    // copies, not the shared constant: mapParent mutates `parent`
    const children: ToolSection[] = sections.map(node => ({ ...node }));
    const root: MenuNode = { key: rootPath, title, children };
    MenuNode.mapParent(children, root);
    commitSelection(rootPath, null, null, null);
    useAppGlobStore.setState({ leftMenu: root });
    setMenuChildren(children);
  }, [rootPath, title, sections]);

  useEffect(() => {
    if (!section || !menuChildren) return;
    GLOB.selectedItem = menuChildren.find(node => node.path === section.path);
  }, [section, menuChildren]);

  if (!menuChildren) return <XmSpinner />;
  if (!section) return <Navigate to={rootPath + sections[0].path} replace />;

  return <>{renderSection(section)}</>;
};
